import * as React from "react";
import { Container, Typography } from "@mui/material";
import { query } from "./graph";
import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { useRouter } from "found";
import AppBar from "../../../components/AppBar";
import ArtReviewOrderDetails from "./components/ArtReviewOrderDetails";
import PendingStatusView from "../../../components/PendingStatusView/PendingStatusView";

const ORDERS_PER_PAGE = 20;

const ArtReviewApp = ({ appBarBackgroundColor, backUrl }) => {
  const [after, setAfter] = useState(null);
  const { router } = useRouter();

  const { loading, error, data, refetch } = useQuery(query, {
    variables: { first: ORDERS_PER_PAGE },
    fetchPolicy: "network-only"
  });

  const handleAppBarRequestBack = () =>
    router.push(backUrl ? backUrl : "/apps");

  useEffect(() => {
    if (
      !loading &&
      !error &&
      !after &&
      data?.ordersConnection.edges.length > 0
    ) {
      const startIndex = Math.floor(
        Math.random() * data.ordersConnection.edges.length
      );
      const { cursor } = data.ordersConnection.edges[startIndex];
      setAfter(cursor);
      return null;
    }
  }, [after, data, error, loading]);

  const currentViewer = !loading && !error ? data.viewer : null;
  if (currentViewer) {
    const {
      me: { id, name }
    } = currentViewer;
    window.analytics.identify(
      Buffer.from(id, "base64").toString("utf8").split(":")[1],
      { name: name }
    );
  }

  const [orderId] =
    !loading && !error
      ? data.ordersConnection.edges
          .filter(({ cursor }) => cursor === after)
          .map(({ node: { id } }) => id)
      : [null];

  const handleOnComplete = () => {
    setAfter(null);
    refetch();
  };

  return (
    <div>
      <AppBar
        title="Art Review"
        onRequestBack={handleAppBarRequestBack}
        backgroundColor={appBarBackgroundColor}
      />
      {loading ? (
        <PendingStatusView status="Loading..." />
      ) : (
        <div>
          {error ? (
            <h6>{error}</h6>
          ) : (
            <>
              {!orderId ? (
                <Container>
                  <br />
                  <br />
                  <Typography variant="h2" align="center">
                    All Art Review Complete
                  </Typography>
                </Container>
              ) : (
                <div>
                  <ArtReviewOrderDetails
                    orderId={orderId}
                    onComplete={handleOnComplete}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ArtReviewApp;
